import React from 'react'
import {Spin} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 45 }} spin />;

function Loading(props) {
    const {loading, children} = props;

    if (children) {
        return (
            <Spin spinning={loading} indicator={antIcon} style={{color: "#ed1a3b"}}>
                {children}
            </Spin>
        );
    }

    return (
        <div style={{ textAlign: 'center' }}>
            <Spin spinning={loading} indicator={antIcon} style={{color: "#ed1a3b"}} />
        </div>
    );
}

export default Loading;
